import React, { useState, useEffect, useCallback } from "react";
import PropTypes from "prop-types";

import TableClientsTotal from "../TableClientsTotal";
import PaginationTab from "../../atoms/PaginationTab";

import api from "../../services/api";
import { formatDate } from "../../utils/date-format";

import {
  ModalContainer,
  ModalContent,
  CloseModal,
  IconCloseModal,
  Title,
  SubTitle,
  TabNavigation,
} from "./styles";

ModalClientsTotal.propTypes = {
  visible: PropTypes.bool.isRequired,
  handleToggleVisibility: PropTypes.func.isRequired,
};

function ModalClientsTotal({ visible, handleToggleVisibility, date }) {
  const [page, setPage] = useState(1);
  const [lastPage, setLastPage] = useState(0);

  const [customers, setCustomers] = useState([]);

  const getCustomersList = useCallback(async (date = "", page) => {
    const { data } = await api.get(
      `/dashboard/active-customers-list?day=${formatDate(
        date,
        "yyyy-MM-dd"
      ).replaceAll("/", "-")}&page=${page}&limit=5`
    );
    setCustomers(data.data);
    setLastPage(data.meta?.last_page);
  }, []);

  useEffect(() => {
    getCustomersList(date, page);
  }, [date, getCustomersList, page]);

  return (
    <ModalContainer visible={visible}>
      <ModalContent>
        <CloseModal onClick={handleToggleVisibility}>
          <IconCloseModal />
        </CloseModal>
        <Title>Clientes ativos ({formatDate(date, "dd-MM-yyyy")})</Title>
        <SubTitle>
          Um cliente ativo é aquele que, no período de até um mês, realizou pelo
          menos um pedido na plataforma Seg Lavanderia.
        </SubTitle>

        <TableClientsTotal customers={customers} />
        {lastPage > 1 && (
          <TabNavigation>
            <PaginationTab
              count={lastPage}
              page={page}
              handleChange={(event, value) => {
                setPage(value);
              }}
            />
          </TabNavigation>
        )}
      </ModalContent>
    </ModalContainer>
  );
}

export default ModalClientsTotal;
